// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SafetyIndicator__root--Esmc {
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: calc(100% + 50px);
    background-color: currentColor;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    border: 1px solid currentColor;
}

    .SafetyIndicator__root--Esmc.SafetyIndicator__high--YXJY {
        color: var(--error-color);
    }

    .SafetyIndicator__root--Esmc.SafetyIndicator__medium--a4JV {
        color: var(--warning-color);
    }

    .SafetyIndicator__root--Esmc.SafetyIndicator__low--bi7C {
        color: var(--success-color);
    }

    .SafetyIndicator__root--Esmc > img {
        position: absolute;
        width: 72px;
        height: 72px;
        bottom: -10px;
        left: -22px;
    }

    .SafetyIndicator__root--Esmc > span {
        text-shadow: 1px 1px 0px 0px #FFFFFF;
        font-weight: 700;
        font-size: 13px;
        line-height: 16px;
        letter-spacing: 0.03em;
        text-transform: uppercase;
        text-align: center;
    }
`, "",{"version":3,"sources":["webpack://./src/ui/components/SafetyIndicator/SafetyIndicator.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,kCAAkC;IAClC,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AA+BlC;;IA7BI;QACI,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,aAAa;QACb,WAAW;IACf;;IAEA;QACI,oCAAoC;QACpC,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,sBAAsB;QACtB,yBAAyB;QACzB,kBAAkB;IACtB","sourcesContent":[".root {\n    width: 100%;\n    height: 56px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-position: bottom;\n    background-repeat: no-repeat;\n    background-size: calc(100% + 50px);\n    background-color: currentColor;\n    border-radius: 6px;\n    overflow: hidden;\n    position: relative;\n    border: 1px solid currentColor;\n\n    &.high {\n        color: var(--error-color);\n    }\n\n    &.medium {\n        color: var(--warning-color);\n    }\n\n    &.low {\n        color: var(--success-color);\n    }\n\n    > img {\n        position: absolute;\n        width: 72px;\n        height: 72px;\n        bottom: -10px;\n        left: -22px;\n    }\n\n    > span {\n        text-shadow: 1px 1px 0px 0px #FFFFFF;\n        font-weight: 700;\n        font-size: 13px;\n        line-height: 16px;\n        letter-spacing: 0.03em;\n        text-transform: uppercase;\n        text-align: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SafetyIndicator__root--Esmc`,
	"high": `SafetyIndicator__high--YXJY`,
	"medium": `SafetyIndicator__medium--a4JV`,
	"low": `SafetyIndicator__low--bi7C`
};
export default ___CSS_LOADER_EXPORT___;
